import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	padding: 20px 20px 0 20px;
`;

const StyledHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

const StyledHeadTitleContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	background-color: #1ab248;
	height: 40px;
	padding: 0 10px;
	border-radius: 10px;

	img {
		width: 14px;
		height: 14px;
		user-select: none;
		pointer-events: none;
	}

	${Text} {
		font-weight: 400;
		font-size: 14px;
		color: #ffffff;
	}
`;

const StyledActiveOrderContainer = styled.div`
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	gap: 10px;
	margin-top: 20px;
`;

const StyledStatsContainer = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 10px;
	margin-top: 10px;
`;

const StyledStatItem = styled.div`
	display: flex;
	align-items: center;
	gap: 20px;
	padding: 0 20px;
	height: 100px;
	background-color: rgba(255, 255, 255, 0.02);
	border: 1px solid rgba(255, 255, 255, 0.05);
	border-radius: 10px;
`;

const StyledStatIconContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 60px;
	height: 60px;
	background-color: rgba(255, 255, 255, 0.05);
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 10px;

	img {
		width: 30px;
		height: 30px;
		user-select: none;
		pointer-events: none;
		opacity: 0.25;
	}
`;

const StyledStatInfoTextContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;

	& > ${Text} {
		&:first-child {
			font-weight: 400;
			font-size: 12px;
			color: #ffffff;
			opacity: 0.5;
		}
	}
`;

const StyledStatInfoValue = styled.div`
	display: flex;
	align-items: center;
	gap: 6px;

	${Text} {
		font-weight: 500;
		font-size: 14px;
		color: #ffffff;
	}

	img {
		opacity: 0.5;
	}
`;

const StyledProgressContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
	margin-top: 30px;
`;

const StyledCompaniesGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	grid-auto-rows: 100px;
	gap: 10px;
	height: 269px;
	overflow-y: scroll;
	padding-bottom: 20px;

	&::-webkit-scrollbar {
		display: none;
	}
`;

const StyledProgressHeadingContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

export {
	StyledActiveOrderContainer,
	StyledCompaniesGrid,
	StyledContainer,
	StyledHeader,
	StyledHeadTitleContainer,
	StyledProgressContainer,
	StyledProgressHeadingContainer,
	StyledStatIconContainer,
	StyledStatInfoTextContainer,
	StyledStatInfoValue,
	StyledStatItem,
	StyledStatsContainer,
};
